import React from "react";
import { GetProfessionalServiceListing } from "../../../redux/features/AttorneyService";
import UserManagementWrapper from "../../Common/UserManagementWrapper";

const ArchivedAttorney = ({ filteredData }) => { // NOSONAR
  const fetchArgs = [
    {
      search: "",
      role: 3,
      status: "0",
    },
    {
      search: "",
      role: 6,
      status: "0",
    }
  ];

  return (
    <UserManagementWrapper
      fetchFunction={GetProfessionalServiceListing}
      fetchArgs={fetchArgs}
      selector={(state) => state.getCombinedListing}
      detailRoute="/professional-service"
      columns={['serviceType']}
      filteredData={filteredData}
    />
  );
};

export default ArchivedAttorney;
